import Client from 'shopify-buy';

export const shopifyClient = Client.buildClient({
  domain: '3jbnc1-pj.myshopify.com',
  storefrontAccessToken: '139f507393ae860e9596138097e98db0',
});
